// Permission Model
cv.Permission = Backbone.RESTModel.extend({
  defaults : {
  },

  saveMap : {
  },

  urlRoot: function(){
    return cv.api_path + '/organizations/' + this.collection.params.organization_id + "/members/" + this.collection.params.member_id + "/permissions";
  },

  initialize: function(){
    console.log('Permission model initialized.');
  }
});
Cocktail.mixin(cv.Permission, cv.mixins.SyncModel);

// Permissions Collection
cv.Permissions = Backbone.Collection.extend({
  initialize: function(){
    console.log('Permissions collection initialized.');
  },

  url: function() {
    return cv.api_path + "/organizations/" + this.params.organization_id + "/members/" + this.params.member_id + "/permissions";
  },

  model: cv.Permission
});
Cocktail.mixin(cv.Permissions, cv.mixins.PaginateModel);
